<button
    (click)="update()"
    class="custom-action--button button -narrow hide-when-print"
    title="{{action.description ? action.description : action.name}}" >
  {{action.name}}
</button>
